<script setup>
import { reactive, onMounted, ref, computed, inject, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()

//路由
const route = useRoute()
const routeSource = route.path.slice(11)
const routeName = route.name
const selectOptions = ref([])

const detailData = inject('detailData', null)
const redesign = inject('algorithmDetailRedesign', false)
const platform = ref('')
let list = ref()
const metricsData = ref([])
const classList = reactive([
  {
    label: '图片解码',
    value: '19.4',
    unit: 'ms',
  },
  {
    label: '解码速度',
    value: '186',
    unit: 'MB',
  },
])

onMounted(async () => {
  initMetrics(detailData.value)
})

watch(
  () => detailData.value,
  (val) => {
    if (val) initMetrics(val)
  },
)

const initMetrics = (res) => {
  if (!res?.metrics) {
    list.value = []
    selectOptions.value = []
    return
  }
  const detail = res.metrics
  const metrics = detail.metrics || []
  metricsData.value = metrics
  selectOptions.value = detail.sdk_platform || []
  platform.value = selectOptions.value[0]?.value || ''
  if (metrics.length > 0) {
    list.value = metrics[0]?.label?.map((item, index) => ({
      label: metrics[0].label[index] || '--',
      unit: metrics[0].unit[index] || '--',
      value: metrics[0].value[index] ?? '--',
    }))
  }
}

const handleChange = (value) => {
  const locationIndex = selectOptions.value.findIndex(
    (item) => item.value === value,
  )
  const data = metricsData.value
  list.value = data[locationIndex]?.label?.map((item, index) => {
    return {
      label: data[locationIndex].label[index],
      unit: data[locationIndex].unit[index],
      value: data[locationIndex].value[index],
    }
  })
}
</script>

<template>
  <div class="section-indicator" v-if="list && list.length > 0">
    <div class="indicator">
      <h2 class="title">关键指标</h2>
      <p class="text-dec">在算法部署中，硬件平台的选择直接影响效率与成本</p>
      <div class="content">
        <div class="text mt10">
          <!-- <span style="width: 300px"></span> -->
          <!-- <span class="text-dec">{{ t('home.indexDec') }}</span> -->
          <span class="text-right flex">
            <label v-if="redesign" for="algorithm-hardware-platform">硬件平台</label>
            <img
              v-if="!redesign"
              srcset="/public/new-image/module.png"
              width="38px"
              height="38px"
            />
            <a-select
              id="algorithm-hardware-platform"
              ref="select"
              v-model:value="platform"
              style="width: 300px; float: right; margin-left: 10px"
              :options="selectOptions"
              @change="handleChange"
            />
          </span>
        </div>
        <div
          class="indicator-list"
          :class="{
            'indicator-list-less': list && list.length > 0 && list.length < 3,
          }"
        >
          <div
            v-for="item in list"
            :key="item.label"
            :class="['indicator-item', item.className]"
          >
            <p class="indicator-num">
              <a>{{ item.value }}</a>
              <span class="unit">{{ item.unit }}</span>
            </p>
            <p class="name">{{ item.label }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
li {
  list-style: none;
}

.section-indicator {
  background-color: #f3f5f5;
}
.indicator {
  .text-dec {
    height: 24px;
    color: #666;
    line-height: 24px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    margin-top: 8px;
  }
  .content {
    .text {
      width: 1133px;
      margin: 40px auto 40px auto;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

    }
  }

  .indicator-list {
    display: flex;
    justify-content: center;
    gap: 100px;
    max-width: 980px;
    height: 119px;
    margin: auto;
    padding-bottom: 119px;

    .indicator-item {
      flex: 0 0 auto;
      width: 260px;
      text-align: center;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      color: #000;

      .indicator-num {
        width: 100%;
        height: 50px;
        font-weight: 400;
        font-size: 40px;
        color: #000000;
        text-align: center;
      }
      .unit {
        font-size: 20px;
        margin-left: 10px;
      }
      .name {
        text-align: center;
        margin-top: 14px;
        margin-bottom: 27px;
        height: 28px;
      }
    }

    .spec {
      .name {
        // height: 56px;
        margin-top: 13px;
        margin-bottom: unset;
        height: calc(100% - 13px - 50px);
      }
    }
  }

  .indicator-list-less {
    justify-content: center;
  }

  .title {
    height: 42px;
    line-height: 40px;
    font-size: 30px;
    font-weight: 500;
    color: #000;
    padding-top: 96px;
    text-align: center;
  }
}

:deep() {
  .ant-select {
    border-radius: 9px;
    .ant-select-selector {
      background-color: #fff;
      border-radius: 22px;
      border: none;
      height: 38px;
    }
    .ant-select-selection-item {
      line-height: 38px;
      text-align: center;
    }
  }
}
</style>
